__turbopack_context__.v({
  "descriptionContainer": "RBa3oW_descriptionContainer",
  "sectionContent": "RBa3oW_sectionContent",
  "sectionTitle": "RBa3oW_sectionTitle",
});
